import { ArrowLeft, RotateCcw } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

interface ErrorProps {
  message?: string;
  onRetry?: () => void;
}

const ErrorComponent: React.FC<ErrorProps> = ({
  message = 'Something went wrong.',
  onRetry,
}) => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-center items-center h-full">
      <Card className="w-[400px]">
        <CardHeader>
          <CardTitle>Error</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <CardDescription>Reason: {message}</CardDescription>
          <Button
            onClick={() => navigate(-1)}
            className="w-full"
            variant="outline"
            startIcon={<ArrowLeft />}
          >
            Go back
          </Button>
          {onRetry && (
            <Button
              onClick={onRetry}
              className="w-full"
              startIcon={<RotateCcw />}
            >
              Retry
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ErrorComponent;
